import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAssetsService } from '../../services/media/media.service';

export const getAssets = createAsyncThunk(
  'media/getAssets',
  async (): Promise<any> => {
    return getAssetsService();
  },
);
